import React from 'react';
import Header from '../components/layout/header';
import Errorsec from '../sections/sec1-error';
import Footerr from '../components/layout/footer';

const Errorr = () => {
    return ( 
        <>
         <Header homeActive="unactive" propertiesActive="unactive" contactActive="unactive" />
         <Errorsec />
         <Footerr />
        </>
     );
}
 
export default Errorr;